/**
 * Request status vocabulary (CT-4200) — its OWN enum, distinct from integration
 * health (CT-4195 `STATUS_BADGE_VARIANT`), audit severity (CT-4184) and publish
 * state (CT-4174). Do not reuse those maps.
 */
export const REQUEST_STATUS = {
  PENDING: 'pending',
  QUOTED: 'quoted',
  IN_PROGRESS: 'in_progress',
  APPROVED: 'approved',
  DELIVERED: 'delivered',
  REJECTED: 'rejected',
};

/** status → @aimsos/ui Badge variant. */
export const REQUEST_STATUS_BADGE_VARIANT = {
  pending: 'alert',
  quoted: 'informative',
  in_progress: 'informative',
  approved: 'success',
  delivered: 'success',
  rejected: 'neutral',
};

/** Inbox status chips — colored border + fill + leading dot (prototype Requests table). */
export const REQUEST_STATUS_CHIP = {
  pending: {
    dot: 'bg-[#EAB308]',
    className: '!border-[rgba(234,179,8,0.35)] !bg-[rgba(234,179,8,0.12)] !text-[#EAB308]',
  },
  quoted: {
    dot: 'bg-purple-400',
    className: '!border-purple-500/30 !bg-purple-500/10 !text-purple-400',
  },
  in_progress: {
    dot: 'bg-teal-400',
    className: '!border-teal-500/30 !bg-teal-500/10 !text-teal-400',
  },
  approved: {
    dot: 'bg-emerald-400',
    className: '!border-emerald-500/30 !bg-emerald-500/10 !text-emerald-400',
  },
  delivered: {
    dot: 'bg-emerald-400',
    className: '!border-emerald-500/30 !bg-emerald-500/10 !text-emerald-400',
  },
  rejected: {
    dot: 'bg-[#EF4444]',
    className: '!border-[rgba(239,68,68,0.30)] !bg-[rgba(239,68,68,0.10)] !text-[#EF4444]',
  },
};

export const requestStatusLabelKey = (status) => `integrations.requests.status.${status ?? 'pending'}`;

/** Inbox filter tabs / Status dropdown (CT-4200). */
export const REQUEST_FILTER_TABS = ['all', 'pending', 'quoted', 'in_progress', 'delivered', 'rejected'];
export const REQUEST_STATUS_FILTERS = REQUEST_FILTER_TABS.filter((tab) => tab !== 'all');
